import MapboxGlLayer from './react-mapbox-gl-leaflet';

export default MapboxGlLayer;
export { MapboxGlLayer };
